import { render, staticRenderFns } from "./ChatHistoryItem.vue?vue&type=template&id=57fd7761&scoped=true"
import script from "./ChatHistoryItem.vue?vue&type=script&lang=js"
export * from "./ChatHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryItem.vue?vue&type=style&index=0&id=57fd7761&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fd7761",
  null
  
)

export default component.exports